
<template>
    <div>
        <div class="bg-overlay"></div>
        <div class="favorites-confirm">
            <h3>{{ trans('talents.selection_remove.title') }}</h3>
            <input type="checkbox" id="dont-show-anymore" class="dont-show-anymore" v-model="dontShowConfirm"><label for="dont-show-anymore">{{ trans('talents.selection_remove.session') }}</label><br>
            <a href="#" class="btn-remove-yes" @click.prevent="removeThisFavorite">{{ trans('talents.selection_remove.yes') }}</a>
            <a href="#" class="btn-remove-no" @click.prevent="hideConfirm">{{ trans('talents.selection_remove.no') }}</a>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'

    export default {
        props: {
            mode: {default: 'default'},
        },
        data: function () {
            return {
                dontShowConfirm: false,
            }
        },
        computed: {
            ...mapState(['deleteFavoriteId']),
        },
        methods: {
            hideConfirm() {
                this.$store.dispatch('showConfirmDeleteFavorite', false)
                let elModel = document.getElementById('model-'+this.deleteFavoriteId)
                elModel.classList.remove('faded')
            },
            removeThisFavorite() {
                this.$store.dispatch('setConfirmDeleteFavorite', !this.dontShowConfirm)
                this.doRemoveFromFavorites()
                this.$store.dispatch('showConfirmDeleteFavorite', false)
            }
        },
    };
</script>